// Common constants for the Finance Tracker app

export const FINANCE_TRACKER_TITLE_PREFIX = 'Finance Tracker';

export const getFinanceTrackerTitle = (year) => `${FINANCE_TRACKER_TITLE_PREFIX} ${year}`;
